import { ILevel } from '../types/tasks.types'
import http, { handleHttpError, handleHttpResponse } from '../shared/http'
import { IPack } from './packs/packs.types'
import { HTTPResponse } from '../shared/http/http.types'

const getList = async (pack: IPack['id']): Promise<ILevel[]> => {
  return http.get(`/api/v1/admin/exercise_levels/?limit=100&pack=${pack}`).then((r) => r.data.results)
}

const create = async (level: Omit<ILevel, 'created' | 'updated'>): Promise<HTTPResponse<ILevel>> => {
  return http.post('/api/v1/admin/exercise_levels/', level).then(handleHttpResponse).catch(handleHttpError)
}

const update = async (levelId: ILevel['id'], updates: Partial<ILevel>): Promise<HTTPResponse<ILevel>> => {
  return http
    .patch('/api/v1/admin/exercise_levels/' + levelId + '/', updates)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const levelsService = { getList, create, update }
export default levelsService
